import React, { Component } from 'react';
import { Link, Navigate, useNavigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import PopupImage from "../Bar/PopupImage";
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomModal from "../Bar/CustomModal";

const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    [{ color: [] }, { background: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    // ['link', 'image', 'video'],
    ['clean'],
  ],
};

export class WordListEdit extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          word_list: {
            sound_name: '',
            sound_url: ''
,           full_sound_url: '',
            upload_progress: 0,
            example: '',
            preview_video_progress: 0,
            full_video_url: '',
            video_name: "",
            video_url: "",
            preview_image_progress: 0,
            full_image_url: '',
            image_name: "",
            image_url: ""
          },
          page: 1,
          all_excercise: {
            title: '',
            example: '',
            questions: []
          },
          folder_id: null,
          show_media: false,
          show_exercise: false,
          show_name_khmer: false,
          show_name_korean: false,
          show_title: false,
          show_description: false,
          show_example: false,

          name_khmer: '',
          name_korean: '',
          word_type_id: 0,
          example: '',
          title: '',
          description: '',
          code: '',
          level: 0,
          type: 0,
          thumbnail: null,
          full_thumbnail: null,
          limit: 100,
          s: '',
          all_word_type: [],

          id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_questions: [],
          fields: {
            name_khmer: "",
            name_korean: "",
            // description: ""
          },
          errors: {},

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          category_id: 1,
          categories: [],
        }
        this.inputRefs = {
          name_khmer: React.createRef(),
          name_korean: React.createRef(),
          // description: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        this.getParam("word_type")
        this.getAllClass();
        this.getAllWordType();
        this.getImage();
      }

      // extractNumber(id) {
      //   const match = id.match(/id: '(\d+)/); 
      //   if (match) {
      //     return parseInt(match[1], 10); 
      //   }
      //   return null; 
      // }
      // getIdFromURL() {
      //   const params = new URLSearchParams(window.location.search);
      //   const id = params.get("id"); 
      //   return id ? parseInt(id, 10) : null; 
      // }

      getParam(name) {
        // const params = new URLSearchParams(window.location.search);
        // console.log(params.get("id"), 'param');
        // console.log(params.get("word_type"), 'parssam');

        let id = window.location.search.split(`${name}=`)[1]
        if (name == "id") {
          this.state.id = id ;
          this.setState({})
          if (id) {
            this.getOneWordList();
          }
        }
        if (name == "word_type") {
          this.state.word_type_id = id;
          this.setState({})
          localStorage.setItem("word_type_id", id);
        }
        
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      goBack = () => {
        this.props.navigate(-1); // Navigate to the previous page
      };

      getAllWordType = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllWordType(query);
          let data = results.data;
          
          this.setState({ all_word_type : data.vocab_folders, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSoundChange = (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        if (!file)
          return ;
        this.state.word_list.sound_name = file.name;
        const formData = new FormData();
        formData.append("file", file);
        this.state.word_list.full_sound_url =  URL.createObjectURL(file);
        this.createAudio();
        this.setState({})
        
        try {
          API.adminUpload(
            formData,
            (percentage) => {
              this.state.word_list.upload_progress = percentage;
              this.setState({})
            }
          ).then(result => {
            this.state.word_list.upload_progress = 100;
            this.state.word_list.sound_url = result.filename;
            this.state.word_list.full_sound_url = result.full_url;
    
            this.setState({})
          }).catch( error => {
            console.log(error)
          }) 
        } catch (error) {
          console.log(error)
        }
      }

      removeAudioQuestion() {
        if (!this.state.word_list.full_sound_url) return;
        var audioElement = document.getElementById("question_audio");
        if (audioElement) {
            audioElement.remove();
        }
      }
    
      createAudio() {
        if (!this.state.word_list.full_sound_url) return;
        var audioElement = document.getElementById("question_audio");
        if (audioElement) {
            audioElement.remove();
        }
        var audio = document.createElement('audio');
        
        // Set the source of the audio file
        audio.src = this.state.word_list.full_sound_url;
        audio.id = "question_audio"
        audio.setAttribute('style', 'width: 100%') 
        // Add controls (optional)
        audio.controls = true;
        
        // Append the audio element to the body
        document.getElementById('audio_src').appendChild(audio);
      }

      onPreviewVideo = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        if (!file) 
          return ;
        const formData = new FormData();
        formData.append("file", file);
    
        
        try {
          let results = await API.adminUpload(
            formData,
            (percentage) => {
              this.state.word_list.preview_video_progress = percentage;
              this.setState({})
                  
              // this.setState({percentage: percentage})
            }
          );
          if (results){
            this.state.word_list.preview_video_progress = 100;
            this.state.word_list.video_url= results.filename;
            this.state.word_list.full_video_url= results.full_url;
            this.setState({})
            this.createVideo();
    
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      removeVideoQuestion() {
        if (!this.state.word_list.full_video_url) return;
        var audioElement = document.getElementById("question_video");
        if (audioElement) {
            audioElement.remove();
        }
      }
    
      createVideo() {
        if (!this.state.word_list.full_video_url) return;
        var videoElement = document.getElementById("question_video");
        if (videoElement) {
            videoElement.remove();
        }
        var video = document.createElement('video');
        
        // Set the source of the audio file
        video.src = this.state.word_list.full_video_url;
        video.id = "question_video"
        video.setAttribute('style', 'width: 100%') 
        video.setAttribute('style', 'height: 460px') 
        // video.setAttribute('style', 'textAlign: center') 
        // video.setAttribute('style', 'display: flex') 
        // video.setAttribute('style', 'justifyContent: center') 
        // video.setAttribute('style', 'alignItems: center') 
        // Add controls (optional)
        video.controls = true;
        
        // Append the audio element to the body
        document.getElementById('video_src').appendChild(video);
      }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          if (!fields[field].trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            if (!firstEmptyField) {
              firstEmptyField = field; // Record the first empty field
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }

      onQuestionFourImageChange = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            (percentage) => {
              this.state.word_list.preview_image_progress = percentage;
              this.setState({})
            }
          );
          if (results){
            this.state.word_list.preview_image_progress = 100;
            this.state.word_list.image_url = results.filename;
            this.state.word_list.full_image_url = results.full_url;
            this.setState({});
            // this.setState({ image_url: results.filename })
          }
    
        } catch (error) {
          toast.error("Oops! Something went wrong. Please try again.", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
          console.log(error)
        }
      }

      getOneQuestion = async (id) => {
        try {
          let query = `id=${id}`
          let results = await API.getOneQuestion(query);
    
          let data = results.data.quiz;
          this.state.added_questions.push(data)
          this.setState({})
        } catch (error) {
          console.log(error)
        }
      }

      getOneWordList = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOneWordList(query);
    
          let data = results.data;

          this.state.word_list.full_image_url = data.full_thumbnail_url;
          this.state.word_list.full_sound_url = data.full_sound_url;
          this.state.word_list.full_video_url = data.full_video_url;
          this.state.word_list.image_url = data.thumbnail_url;
          this.state.word_list.sound_url = data.sound_url;
          this.state.word_list.video_url = data.video_url;
          this.state.name_khmer = data.name_khmer;
          this.state.name_korean = data.name_korean;
          this.state.fields.name_khmer = data.name_khmer;
          this.state.fields.name_korean = data.name_korean;
          this.state.title = data.title;
          this.state.description = data.description;
          this.state.example = data.example;
          this.state.code = data.code;
          this.state.level = data.level;
          this.state.type = data.type;
          this.state.word_type_id = parseInt(data.type, 10);

          let exercise = JSON.parse(data.exercise);
          this.state.all_excercise.title = exercise.title;
          this.state.all_excercise.example = exercise.example;
          this.state.all_excercise.questions = exercise.questions;

          // this.state.all_excercise = JSON.parse(data.exercise);


          this.setState({});
          this.createAudio();
          this.createVideo();
    
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneBranch = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOneBranch(query);
    
          let data = results.data;

          this.setState({ 
            added_questions: data.classroom,
            data : data, 
            code: data.code,
            description: data.description,
            name: data.name,
            thumbnail: data.thumbnail_url
          });
    
        } catch (error) {
          console.log(error)
        }
      }

      getAllClass = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllClass(query);
          let data = results.data;
          
          this.setState({ quizs : data.class, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        let value = event.target.value;
        this.state.s = value;
        this.setState({});
        // this.getA()
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ data: {
      //     ...this.state.data,
      //     [name]: value
      //   }})
      // }
      
      onRemoveQuestion(data){
        this.state.added_questions.splice(this.state.added_questions.indexOf(data), 1);
        this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      deleteFolder = async (event) => {
        event.preventDefault();
        let data = {
          id : this.state.data.id
        }
        try {
          let results = await API.postDeleteWordList(data);
          
          if (results.result){
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            this.getAllWordList();
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      onAddQuestion(data  = {}) {
        data.new = true;
        this.state.added_questions.unshift(data);
        
        // this.state.added_questions.push(data)
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }
      onRemoveChild(data){
        this.state.all_excercise.questions.splice(this.state.all_excercise.questions.indexOf(data), 1);
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        this.setState({})
    
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        if (this.state.word_type_id == 0 || this.state.word_type_id === undefined || this.state.word_type_id === null ){
          toast.error("Please select word type", {
            data: {
              title: "Erro toast",
              text: "This is a error message",
            },
          })
          return 
        }

        // if (!this.validateFields()) return;
         let data = {
          id: this.state.id? parseInt(this.state.id, 10): this.state.id,
          // type: localStorage.getItem("word_type_id"),
          // id: this.state.id,
          type: this.state.word_type_id,
          name_khmer: this.state.name_khmer,
          name_korean: this.state.name_korean,
          title: this.state.title,
          description: this.state.description,
          example: this.state.example,
          code: this.state.code,
          thumbnail_url: this.state.word_list.image_url,
          sound_url: this.state.word_list.sound_url,
          video_url: this.state.word_list.video_url,
          // type: this.state.type,
          level: this.state.level,
          exercise: JSON.stringify(this.state.all_excercise)
         }

        try {
          let results = await API.postOneWordList(data);
          if (results.result === 1){
            // this.goBack();
            
            this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      
      addMultiQuestion(data) {
        return <div className="card">
      
          
      
          <div className="col-md-12">
          {/* { this.state.all_excercise.questions &&
        this.state.all_excercise.questions.map(question => {
          return   */}

            <div className="row">
          
          <div className="form-group col-md-12" >
              <label className="require" for="input-required">Content</label>
              <ReactQuill 
                theme="snow" 
                modules={modules}
                style={{"height" : "250px"}} 
                value={data.content} 
                // onChange={this.handleInputChange} 
                onChange={(value) => {
                  data.content = value;
                  this.setState({})
                }} 
                />
                <br />
          </div>

          {data.answers.map((ans, index) => {
            return <div className="col-md-6">
              <div className="form-group " style={{marginTop: 30}}>
                <label className="require" for="input-required"> Answer {index+1}</label>
                <input className="form-control" type="text" 
                  onChange={(event) => {
                  ans.text = event.target.value;
                  this.setState({})
                }} 
                value={ans.text}
                />
              </div>
          </div>
          })}

            <div className="form-group col-md-6">
              <strong>Correct Answer</strong>
              <div class="card">
                    {/* <input className="form-control" type="text" 
                      ref = {ref => data.ref = ref}
                      onChange={(event) => {
                        question.correct_answer = event.target.value;
                        this.setState({})
                    }} 
                    value={question.correct_answer}
                    /> */}
                    <select focus={true} className="form-control" value={data.correct_answer} name="level"
                        onChange={(event) => {
                          data.correct_answer = event.target.value;
                          this.setState({})
                        }}>
                          {/* <option value="" disabled>
                          Select an option
                        </option> */}
                        <option value={0}>
                          Please select answer
                        </option>
                        <option value={1}>Answer 1</option>
                        <option value={2}>Answer 2</option>
                    </select>
                </div>
              
          </div>

        </div>
        
        {/* }) */}
       {/* } */}
            
            
        </div>
        {/* custom modal */}
        <div className="modal modal-center fade" id="modal-center" tabindex="-1">
            <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">Do you really want to delete this exercise?</h5>
                <button type="button" class="close" data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div className="modal-body">
                <h6> 
                  {/* Do you really want to delete this episode? */}
                </h6>
                <img className='center' src={deleteGif} width="500" height="350" />
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-bold btn-pure btn-secondary" data-dismiss="modal" onClick={() => data = null}>Close</button>
                <Link type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={() => this.onRemoveChild(data)}>
                  Save changes</Link>
                </div>
            </div>
            </div>
        </div>
    
    
        <footer className="card-footer ">
          <div className="text-right">
            <Link className="btn btn-danger" data-toggle="modal" data-target="#modal-center" >Remove</Link>
            {/* <button className="btn btn-danger" data-toggle="modal" data-target="#modal-center" onClick={() => this.onRemoveChild(data)} >Remove</button> */}
            {/* <button className="btn btn-primary" onClick={() => this.onEpisodeSave(data)}>Save</button> */}
          </div>
        </footer>
      </div>
      } 

  render() {
    const { fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {
            this.state.show_exercise && <div className="float_plus_button">
            <button className="btn btn-float btn-primary" onClick={this.onAddChild}>  <i className="ion-plus-round"></i></button>
          </div>
          }
          {this.state.success && (
              <Navigate to={`/wordtypeview?id=${this.state.word_type_id}`} replace={true} />
              // <Navigate to={`/wordtypeedit?id=${this.state.word_type_id}&success=true`} replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title"><strong>Word List</strong></h4>

                <div className="card-body row">

                  <div className="col-md-6">
                    <div className="form-group">
                      <input type="checkbox" className="big-checkbox" onChange={(event) => {
                          this.state.show_name_korean = event.target.checked;
                          this.setState({});
                        }} />&emsp;
                      <label>Name Korean</label> 
                      {
                        !this.state.show_name_korean && <input type="text" className="form-control" id="input-required" value={this.state.name_korean} name='name_korean' 
                        
                        onChange={(event) => {
                          this.state.name_korean = event.target.value;
                          this.setState({})
                        }} />
                      }
                      {
                        this.state.show_name_korean && <ReactQuill 
                        theme="snow" 
                        modules={modules}
                        style={{"height" : "150px", marginTop: 10}} 
                        value={this.state.name_korean} 
                        onChange={(value) => {
                          this.state.name_korean = value;
                          this.setState({})
                        }}  
                        />
                      }
                      {
                        this.state.show_name_korean && <div>
                          <br /><br /><br />
                        </div>
                      }

                      
                      
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input type="checkbox" className="big-checkbox" onChange={(event) => {
                          this.state.show_name_khmer = event.target.checked;
                          this.setState({});
                        }} />&emsp;
                      <label>Name Khmer</label>
                      {
                        !this.state.show_name_khmer && <input type="text" className="form-control" id="input-required" value={this.state.name_khmer} name='name_khmer' 
                        
                        onChange={(event) => {
                          this.state.name_khmer = event.target.value;
                          this.setState({})
                        }} />
                      }
                      {
                        this.state.show_name_khmer && <ReactQuill 
                        theme="snow" 
                        modules={modules}
                        style={{"height" : "150px", marginTop: 10}} 
                        value={this.state.name_khmer} 
                        onChange={(value) => {
                          this.state.name_khmer = value;
                          this.setState({})
                        }}  
                        />
                      }
                      {
                        this.state.show_name_khmer && <div>
                          <br /><br /><br />
                        </div>
                      }
                    </div>
                  </div>

                    {/* <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name Korean</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.name_korean} name='name_korean' 
                        ref={this.inputRefs.name_korean}
                        style={{
                          border: errors.name_korean ? "1px solid red" : "", 
                        }}
                        onChange={(event) => {
                          this.state.name_korean = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                        }} />
                        {errors.name_korean && <span style={{ color: "red" }}>{errors.name_korean}</span>}
                    </div>
                    
                    </div>
                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name Khmer</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.name_khmer} name='name_khmer' 
                        ref={this.inputRefs.name_khmer}
                        style={{
                          border: errors.name_khmer ? "1px solid red" : "", 
                        }}
                        onChange={(event) => {
                          this.state.name_khmer = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                        }} />
                        {errors.name_khmer && <span style={{ color: "red" }}>{errors.name_khmer}</span>}
                    </div>
                    
                    </div> */}
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label>Code</label>
                        <input className="form-control" type="text" value={this.state.code} name='code' onChange={(event) => {
                          this.state.code = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div>
                    <div className="col-md-6"></div> */}


                    <div className="col-md-6">
                      <div className="form-group">
                        <input type="checkbox" className="big-checkbox" onChange={(event) => {
                            this.state.show_title = event.target.checked;
                            this.setState({});
                          }} />&emsp;
                        <label>Title</label>
                        {
                          !this.state.show_title && <input type="text" className="form-control" id="input-required" value={this.state.title} name='title' 
                        
                          onChange={(event) => {
                            this.state.title = event.target.value;
                            this.setState({})
                          }} />
                        }
                        {
                          this.state.show_title && <ReactQuill 
                          theme="snow" 
                          modules={modules}
                          style={{"height" : "150px", marginTop: 10}} 
                          value={this.state.title} 
                          onChange={(value) => {
                            this.state.title = value;
                            this.setState({})
                          }}  
                          />
                        }
                        {
                          this.state.show_title && <div>
                            <br /><br /><br />
                          </div>
                        
                        }
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input type="checkbox" className="big-checkbox" onChange={(event) => {
                            this.state.show_description = event.target.checked;
                            this.setState({});
                          }} />&emsp;
                        <label>Description</label>
                        {
                          !this.state.show_description && <input type="text" className="form-control" id="input-required" value={this.state.description} name='description' 
                        
                          onChange={(event) => {
                            this.state.description = event.target.value;
                            this.setState({})
                          }} />
                        }
                        {/* <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                        }} /> */}
                        {
                          this.state.show_description && <ReactQuill 
                          theme="snow" 
                          modules={modules}
                          style={{"height" : "150px", marginTop: 10}} 
                          value={this.state.description} 
                          onChange={(value) => {
                            this.state.description = value;
                            this.setState({})
                          }}  
                          />
                        }
                        {
                          this.state.show_description && <div>
                            <br /><br /><br />
                          </div>
                        
                        }
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input type="checkbox" className="big-checkbox" onChange={(event) => {
                            this.state.show_example = event.target.checked;
                            this.setState({});
                          }} />&emsp;
                        <label>Example</label>
                        {
                          !this.state.show_example && <text type="text" className="form-control" id="input-required" value={this.state.example} name='example' 
                        
                          onChange={(event) => {
                            this.state.example = event.target.value;
                            this.setState({})
                          }} />
                        }
                        {/* <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                        }} /> */}
                        {
                        this.state.show_example &&<ReactQuill 
                        theme="snow" 
                        modules={modules}
                        style={{"height" : "150px", marginTop: 10}} 
                        value={this.state.example} 
                        onChange={(value) => {
                          this.state.example = value;
                          this.setState({})
                        }}  
                        />
                        }
                        {
                        this.state.show_example && <div>
                          <br /><br /><br />
                        </div>
                      }
                      </div>
                    </div>

                    {/* <div className='col-md-6'></div> */}
                    <div className='col-md-6'>
                      <div className="form-group">
                        <label >Word Type</label>
                        <select id="inputState" className="form-control" value={this.state.word_type_id} name="word_type_id" 
                            
                            onChange={(event) => {
                              this.state.word_type_id = event.target.value;
                              this.setState({})
                              // this.handelInput(event)
                            }}>
                            <option value={0}>Please select type</option>
                            {
                              this.state.all_word_type.map((topic, index) => {
                              return <option value={topic.id}>{index + 1 + `.`}{<strong dangerouslySetInnerHTML={{ __html: topic.name_korean }}></strong>} {<strong dangerouslySetInnerHTML={{ __html: topic.name_khmer }}></strong>}</option>
                            })}
                        </select>
                      </div>
                    </div>
                    
                    {/* <div className="col-md-6"></div> */}
                    <div className="col-md-6">
                      <div className="form-group">
                        <input type="checkbox" className="big-checkbox" onChange={(event) => {
                            this.state.show_media = event.target.checked;
                            this.setState({});
                          }} />&emsp;
                        <label >1. Show Media </label> &emsp;
                        &emsp;
                        <input type="checkbox" className="big-checkbox" onChange={(event) => {
                          this.state.show_exercise = event.target.checked;
                          this.setState({});
                        }} />&emsp;
                        <label >2. Show Exercises </label> &emsp;
                        
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                    
                    
                    {
                      this.state.show_media && <div className='col-md-6'>
                      <div className="form-group">
                        {/* <label className="require" for="input-required">Level </label> */}
                        <label >Level </label>
                        <select id="inputState" className="form-control" value={this.state.level} name="level"
                            // ref={this.inputRefs.level} 
                            // style={{
                            //   border: errors.level ? "1px solid red" : ""
                            // }}
                            onChange={(event) => {
                              this.state.level = event.target.value;
                              this.setState({})
                              this.handelInput(event)
                            }}>
                            <option value={0}>Please select level</option>
                            <option value={1}>Level 1</option>
                            <option value={2}>Level 2</option>
                            <option value={3}>Level 3</option>
                        </select>
                        {/* {errors.level && <span style={{ color: "red" }}>{errors.level}</span>} */}
                      </div>
                    </div>
                    }

                    {
                      this.state.show_media && <div className="col-md-6">
                      <div className='form-group'> 
                      <label >Sound</label>  
                        <input type="file" id="des" hidden className="form-control" accept="audio/mp3"
                          onChange={(e) => this.onSoundChange(e)}
                        />  
                        <button onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("des").click()
                        }} type="buttom" className={`form-control ${this.state.word_list.sound_name ? 'btn-primary' : 'btn-info'}`} ><span style={{color: 'black'}}>{this.state.word_list.sound_name? this.state.word_list.sound_name : 'Upload Sound'}</span>
                        </button> 
                        <div id="audio_src">

                        </div>
                      </div>
                    </div>
                    }
                    {/* <div className='col-md-6'></div> */}

                    {
                      this.state.show_media && <div className='col-md-6'>
                      <div className="form-group">
                        <label >Image</label> &emsp;
                        <div style={{
                            marginTop: '10px',
                            textAlign: 'center', 
                            // MaxHeight: '50px',
                            height: this.state.word_list.full_image_url ? '250px' : 0,
                            // objectFit: 'cover'
                            display: 'flex', // Flexbox for alignment
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            }}>
                        {
                          this.state.word_list.full_image_url && <PopupImage
                          thumbnailUrl={this.state.word_list.full_image_url} 
                          imageUrl={this.state.word_list.full_image_url} 
                        />
                        }
                      </div>
                        <input type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onQuestionFourImageChange(e)} /> 
                        <div class="progress">
                          <div class="progress-bar" role="progressbar" style={{width: this.state.word_list.preview_thumbnail_progress + "%", height: "10px"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.word_list.preview_thumbnail_progress ? this.state.word_list.preview_thumbnail_progress + "%" : null}</strong></div>
                        </div>  
                      </div> 
                    </div>
                    }
                    {
                      this.state.show_media && <div className='col-md-6'>
                      <div className="form-group">
                        {/* <label style={{paddingTop: '10px', paddingBottom: '18.5px'}}>Video Details </label> */}
                        <label style={{paddingBottom: '8px'}}>Video Details </label>
                        
                          <div id="video_src" style={{display: 'flex', // Flexbox for centering
                            justifyContent: 'center', // Align horizontally
                            alignItems: 'center', // Align vertically
                            width: '100%', // Set a fixed width for the container
                            height: this.state.word_list.full_video_url ? '460px' : '0', // Set a fixed height for the container
                            // border: '1px solid #ddd',
                            borderRadius: '5px',
                            overflow: 'hidden', // Prevent overflow
                            margin: '0 auto', // Center the container itself horizontally
                            // backgroundColor: '#f9f9f9',
                            }}>

                          </div>  
                          <div style={{paddingTop: '3px'}}></div>    
                        <input 
                        accept="video/mp4"
                        onChange={(e) => this.onPreviewVideo(e)}
                        type="file" data-provide="dropify" />
                        <div class="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" 
                              style={{width: this.state.word_list.preview_video_progress + "%", height: "10px"}}
                              >
                                <strong>{this.state.word_list.preview_video_progress ? this.state.word_list.preview_video_progress + "%" : null}</strong>
                            </div>
                        </div>
                    </div>
                    </div>
                    }

                    {
                      this.state.show_media &&   <div className="col-md-6" style={{paddingTop: '8px'}}>
                    <div className="">
                      <button  type="buttom" className="btn btn-danger" 
                        onClick={(e) => {

                          e.preventDefault()
                          this.removeAudioQuestion();
                          this.state.word_list.full_sound_url = null;
                          this.state.word_list.sound_url = '';
                          this.state.word_list.sound_name = null;
                          
                          this.setState({});
                          }}><i class="fa fa-trash"></i>Sound</button> &emsp;

                      <button  type="buttom" className="btn btn-danger" onClick={(e) => {
                        e.preventDefault()
                        this.state.word_list.full_image_url = '';
                        this.state.word_list.image_name = '';
                        this.state.word_list.image_url = '';
                        // this.state.word_list.pre= 0;

                        this.setState({});
                        }}><i class="fa fa-trash"></i>Image</button>&emsp;
                        <button  type="buttom" className="btn btn-danger" 
                          onClick={(e) => {

                            e.preventDefault()
                            this.removeVideoQuestion();
                            this.state.word_list.full_video_url = '';
                            this.state.word_list.video_url = '';
                            this.state.word_list.preview_video_progress= 0;
                            // this.state.questions.v = null;
                            
                            this.setState({});
                            }}><i class="fa fa-trash"></i>Video</button>
                    </div>
                  </div>
                  }
                </div>

                <div className="">
                  
                  
                  
                </div>

                

                


                {/* add questions */}
            </form>

            {
              this.state.show_exercise && <div className="card">
              <h4 className="card-title"><strong>Exercises</strong></h4>
              <div className="card-body row">
              <div className="form-group col-md-12">
                <label className="require" for="input-required">Title</label>
                  <ReactQuill 
                      theme="snow" 
                      modules={modules}
                      style={{"height" : "250px", marginTop: 10}} 
                      value={this.state.all_excercise.title} 
                      onChange={(value) => {
                        this.state.all_excercise.title = value;
                        this.setState({})
                      }} 
                      />
                  </div>
                  <div className="form-group col-md-12" style={{marginTop: 50}} >
                      <label className="require" for="input-required">Example</label>
                      {/* <textarea type="text" className="form-control" id="input-required"
                        onChange={(event) => {
                          data.description_kh = event.target.value;
                          this.setState({})
                        }} 
                        value={data.description_kh}
                      /> */}
                      <ReactQuill 
                        theme="snow" 
                        modules={modules}
                        style={{"height" : "250px", marginTop: 10}} 
                        value={this.state.all_excercise.example} 
                        onChange={(value) => {
                          this.state.all_excercise.example = value;
                          this.setState({})
                        }}  
                        />
                        <br /><br />
                  </div>
                
              </div>
              { this.state.all_excercise.questions.map(data => {
                  return this.addMultiQuestion(data);
                })}
              
            </div>
            }
            <footer className="card-footer text-right">
              <Link className="btn btn-secondary" onClick={() => this.goBack()}>Back</Link>
                {/* <Link className="btn btn-secondary" to ={`/wordtypeview?id=${this.state.word_type_id}`}>Back</Link> */}
                
                {/* <button className="btn btn-primary" onClick={this.handleSubmit} type="submit">Submit</button> */}
                <button className="btn btn-primary" onClick={(event) => this.handleSubmit(event)} type="submit">Submit</button>
              </footer>
            {
              this.state.data &&
              <CustomModal 
                data={ this.state.data }  
                title="Do you really want to delete this word?"
                deleteQuiz = {this.deleteFolder}
              />
           }

        </div>
    )
  }
  onAddChild = () => {
    this.state.all_excercise.questions.push({
      correct_answer: null,
      content: "",
      answers: [
        {
          text: ""
        },
        {
          text: ""
        }
      ],
    });

    setTimeout(() => {
      if (this.state.all_excercise.questions.length !== 1) {
        window.scrollTo({
          bottom: 2800,
          behavior: "smooth"
        })
        // data.ref.focus();
        
      }
    }, 300);

    this.setState({})
  }
}
const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <WordListEdit navigate={navigate} />;
};

export default MyComponentWithNavigate